import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { SingleSelect } from "~/components/Select/SingleSelect";
const dateTypeOptions = [
    {
        value: "today",
        label: "Today"
    },
    {
        value: "yesterday",
        label: "Yesterday"
    },
    {
        value: "last-week",
        label: "Last week"
    },
    {
        value: "last-month",
        label: "Last month"
    },
    {
        value: "last-year",
        label: "Last year"
    },
    {
        value: "custom-range",
        label: "Custom date range"
    }
];
export const DateFilterTypeSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedType, onTypeChange } = param;
    const onSelectionChange = useCallback((param)=>{
        let { chips } = param;
        onTypeChange(chips[chips.length - 1].value);
    }, [
        onTypeChange
    ]);
    const selectedDate = dateTypeOptions.find((option)=>option.value === selectedType);
    return /*#__PURE__*/ _jsx(SingleSelect, {
        size: "large",
        options: dateTypeOptions,
        selectedOption: selectedDate,
        onSelectionChange: onSelectionChange,
        placeholder: "Select date...",
        className: "mb-4"
    });
});
DateFilterTypeSelect.displayName = "DateFilterTypeSelect";
